<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">대표이사 프로필<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="sub1">
          <div>
            대표이사 강정하는 이화여자대학교에서 교육심리학으로 학사, 석사
            과정을, 성균관대학교에서 영재 및 창의성 교육 전공으로 박사 과정을
            마쳤습니다. 학문을 시작한 초기 10년 동안은 '인간의 창의성 발현'을
            '자기조직화' 현상으로 설명하는 이론 연구에 전념하였습니다. 이후,
            KAIST 과학영재교육연구원 연구교수로 재직한 10년 동안은 전국 과학고
            및 과학영재학교의 새로운 인재선발제도 도입 및 정착 지원, 표준
            교육과정 개발, 진로상담지원체계 구축 방안 연구, 교원 전문성 연수
            등을 수행하면서 우리의 교육을 새롭게 하는 일에 집중했습니다. 회사
            설립과 동시에 성균관대학교 겸임교수, 영재교육원 부원장으로 활동한
            최근 5년 동안은 '새 시대에 새 꿈을 품는 새로운 교육'을 구현하기 위한
            다원적 및 다중적 '학습진로진학상담' 교육 및 진단 시스템 구축에
            매진하고 있습니다. 그 외, 미술, 음악, 무용 분야에도 관심을 가지고
            연구 및 다양한 활동을 지속해오고 있습니다.
          </div>

          <table>
            <colgroup>
              <col width="25%" />
              <col width="75%" />
            </colgroup>
            <thead>
              <tr>
                <th>주요 논문</th>
                <td></td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colspan="2">
                  강정하†‡ · 석혜은 · 박선희 · 신학수 · 홍성호 · 박청담 · 윤지윤
                  (2018). 과학영재 지식창출 경험에 대한 학생 인식조사: 전문가
                  연구 활동에
                  <span
                    >대한 IPA 및 네트워크 분석을 중심으로. 창의력교육연구,
                    18(4), 23-45.</span
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  강정하†‡ · 박선희† · 신학수 · 홍성호 (2018). 지속성장형
                  과학영재 자율연구 사례조사: 세계 명문대를 중심으로.
                  영재교육연구, 28(1), 63-89.
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  강정하† · 이병임‡ (2018). 과학영재 진로결정을 지원하는 교사
                  활동에 대한 실태조사: 영재학교‧과학고를 중심으로.
                  <span>학습자중심교과교육학회지, 18(5), 821-845.</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  강정하†‡ · 박선희 · 김 철 · 문경호 · 김영민 · 석혜은 (2017).
                  과학인재의 지속성장 기제로서의 창의성 탐색: 이공계 대학생
                  창의역량 모델링을
                  <span>통해. 창의력교육연구, 17(4), 19-55.</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  강정하†‡ · 권경아† · 석혜은 (2017). 과학영재 진로결정의
                  개념모델 타당화 및 요구 분석: 국가수준 과학영재교육 기관을
                  중심으로.
                  <span>영재교육연구, 27(4), 717-743.</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  강정하†‡ · 임지영 · 김아영 (2017). 과학적 창의성검사의 타당화.
                  영재와 영재교육, 16(1), 87-127
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하†‡ · 권경아 · 박민서 · 홍성호 (2016). 과학창의인재
                  추수관리 실태조사와 교육적 시사: 과학고 ‧ 과학영재학교를
                  중심으로.
                  <span>창의력교육연구, 16(4), 69-89. </span>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  김영민 · 강정하 · 허남영 (2015). 과학영재학생의 공학에 대한
                  이미지와 인식 분석. 영재교육연구, 25(1), 95-117.
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하† · 허남영‡ · 백민정 · 한기순 (2014). 과학영재 추수관리
                  모델 개발 예비연구: 국가수준 과학영재교육기관 사례를 중심으로.
                  <span>영재교육연구, 24(6), 975-1000.</span>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하†‡ · 조선희 · 김미진 (2014). 과학 분야 창의적 산물
                  발현과정 연구: 과학자의 주관적 경험이 객관적 지식으로 발현하는
                  자기조직화
                  <span>과정의 사례 분석. 영재교육연구, 24(1), 113-147. </span>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하†‡ · 최인수 (2009). 과학적 창의성의 발달: 창의적 한국인
                  사례에 대한 전기적 연구. 영재교육연구, 19(3), 529-563.
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하 (2009). 과학적 창의성의 발현. 과학기술정책, 여름, 8-15.
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하†‡ · 최인수 (2008). 과학적 창의성: 지식의 성장으로서의
                  창의성에 대한 사례연구. 교육심리연구, 22(3), 537-562.
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하†‡ · 최인수 (2008). 과학적 창의성과 시각예술적 창의성:
                  창의적 성취사례의 영역보편성과 영역특정성. 영재교육연구,
                  18(2),
                  <span>201-237.</span>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  강정하† · 최인수‡ (2006). 창의적 문제해결력 프로그램이
                  대학생의 창의적 문제해결 성향과 수행능력에 미치는 효과.
                  교육심리연구, 20(3),
                  <span>679-701.</span>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="txt">㈜ †: 주저자, ‡: 교신저자</p>

          <br /><br />

          <table>
            <colgroup>
              <col width="25%" />
              <col width="75%" />
            </colgroup>
            <thead>
              <tr>
                <th>출판</th>
                <td></td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">PUTT2.0 진단지침서. 강정하‧김성호‧김종헌‧김민진, 2023. ㈜COKOLab.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-981777-0-4 94180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-011636 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">PUTT2.0_초등학생용(고). 강정하‧김성호‧김종헌, 2023. ㈜COKOLab.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-981777-5-9 93180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-010652-2 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">PUTT2.0_중학생용. 강정하‧김성호‧김종헌, 2023. ㈜COKOLab. </div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-981777-4-2 93180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-010652-2 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">PUTT2.0_고등학생용. 강정하‧김성호‧김종헌‧김민진, 2023. ㈜COKOLab.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-981777-2-8 93180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-011635 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">PUTT2.0_대학생용. 강정하‧김성호‧김종헌, 2023. ㈜COKOLab.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-981777-0-4 93180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-010652-2 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">TEC 진단지침서. 강정하‧김성호‧김종헌, 2023. ㈜COKOLab.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-982315-3-6 93180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-013270 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">TEC_전문가용. 강정하‧김성호‧김종헌, 2023. ㈜COKOLab.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-981777-3-5 93180;</div>
                    <div style="flex: 0 0 35%; border: none; padding: 0 10px 0 0; margin: 0;">저작권등록번호 제 C-2023-013270 호;</div>
                    <div style="flex: 0 0 32%; border: none; padding: 0; margin: 0;">상표등록번호 제 40-1746432 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">TOCC 전문가 지침서. 강정하‧김아영, 2020. ㈜COKOLab & ㈜인싸이트.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;">ISBN 979-11-6485-031-0 93180;</div>
                    <div style="flex: 0 0 45%; border: none; padding: 0; margin: 0;">출판등록번호 제 2015-000357 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">TOCC_아동용. 강정하‧김아영, 2020. ㈜COKOLab & ㈜인싸이트.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;"></div>
                    <div style="flex: 0 0 45%; border: none; padding: 0; margin: 0;">출판등록번호 제 2015-000357 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; border-bottom: 1px solid #eaeaea; padding: 0 0 8px 0; margin: 0 0 8px 0; font-weight: 600; color: #333;">TOCC_청소년용. 강정하‧김아영, 2020. ㈜COKOLab & ㈜인싸이트.</div>
                  <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="flex: 0 0 33%; border: none; padding: 0 10px 0 0; margin: 0;"></div>
                    <div style="flex: 0 0 45%; border: none; padding: 0; margin: 0;">출판등록번호 제 2015-000357 호</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 15px;">
                  <div style="border: none; padding: 0; margin: 0 0 12px 0; width: 100%; border-bottom: 1px dashed #ccc; padding-bottom: 5px; font-weight: 600; color: #333;">생각아이 4편11권. 강정하‧최인수 외 다수, 2007. 아이코리아.</div>
                  <div style="display: flex; flex-direction: column; width: 100%; border: none; padding: 0; margin: 0;">
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 1 - 자랑스런 나.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-569-3</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 2 - 식물과 곤충.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-570-9</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 3 - 가족.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-571-6</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 4 - 지역 사회.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-591-4</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 5 - 놀이와 운동.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-592-1</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 6 - 집 그리고 산들강.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-593-8</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 7 - 탈 것.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-595-2</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 8 - 소중한 유산.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-596-9</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 9 - 지구 그리고 해달별.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-597-6</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0 0 3px 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 10 - 과학기술.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-606-5</div>
                    </div>
                    <div style="display: flex; width: 100%; border: none; padding: 0; margin: 0;">
                      <div style="flex: 0 0 45%; border: none; padding: 0 10px 0 0; margin: 0;">+ 생각아이 11 - 보살피기.</div>
                      <div style="flex: 0 0 55%; border: none; padding: 0; margin: 0;">ISBN 978-89-8295-607-2</div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");
  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub1 div {
  font-size: 16px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  line-height: 1.7em;
  border: 1px dashed #ccc;
  padding: 20px;
  margin-bottom: 30px;
  word-break: keep-all;
}
.sub1 table {
  width: 100%;
}
.sub1 table th {
  font-weight: 500;
  background: #f5f5f5;
}
.sub1 table tr:nth-child(1) th {
  font-size: 16px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  background: #ba7b3d;
  color: #fff;
  box-sizing: border-box;
  font-weight: 500;
}

.sub1 table th,
.sub1 table td {
  font-size: 15px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  color: #444;
  line-height: 1.7em;
  word-break: keep-all;
  padding: 10px;
  word-break: keep-all;
  border: 1px solid #ddd;
}
.sub1 p {
  font-size: 15px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  color: #ff0000;
  padding-top: 10px;
}
.sub1 p.txt {
  color: #444;
}

.sub1 table td ul {
  margin: 0;
  padding: 0;
}
.sub1 table td ul li {
  font-size: 15px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  color: #444;
  line-height: 1.7em;
  word-break: keep-all;
  word-break: keep-all;
  list-style: circle;
  margin-left: 1.2em;
}
.sub1 table td ul li.dot {
  list-style: disc;
}

@media screen and (min-width: 1100px) {
  .sub1 table td span {
    display: block;
    padding-left: 2.5em;
  }
}
</style>
